import { Controller } from "@hotwired/stimulus";

const byRole = (el, role) => el.querySelector(`[data-role="${role}"]`);

/**
 * Renders the audio bar in the soundtrack track.
 *
 * The parent tracks controller clones the template, sets data-*-value
 * attributes, and appends it — this controller reacts via valueChanged
 * callbacks and keeps the DOM in sync.
 */
export default class extends Controller {
  static values = {
    left: String,
    width: String,
    selected: Boolean,
    waveform: Array, // [{ cls, height }]
    name: String,
  };

  leftValueChanged(v) { this.element.style.left = v; }
  widthValueChanged(v) { this.element.style.width = v; }

  selectedValueChanged(v) {
    this.element.toggleAttribute("data-selected", v);
    byRole(this.element, "label")?.toggleAttribute("data-selected", v);
    byRole(this.element, "handle-l")?.firstElementChild?.toggleAttribute("data-selected", v);
    byRole(this.element, "handle-r")?.firstElementChild?.toggleAttribute("data-selected", v);
  }

  waveformValueChanged(bars) {
    const el = byRole(this.element, "waveform");
    if (!el || !bars?.length) return;
    el.innerHTML = bars
      .map(b => `<span class="w-0.5 shrink-0 rounded-full ${b.cls}" style="height:${b.height}%"></span>`)
      .join("");
  }

  nameValueChanged(v) {
    const el = byRole(this.element, "name");
    if (el) el.textContent = v;
  }
}
